<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import {resetCurrentPassword} from '../../../api/services/resetTicket.service'

import { required } from "vuelidate/lib/validators";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Reset Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      confirmPassword: null,
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      successMsg: null,
      isSuccess: false,
      email: localStorage.getItem('email')
    };
  },
  validations: {
    currentPassword: {
      required,
    },
    newPassword: {
      required,
    },
    confirmPassword: {
      required
    }
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    async tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else if(this.newPassword !== this.confirmPassword){
        this.error = "New password and confirm password are not the same!"
        this.isResetError = true;        
      }else{
        const res = await resetCurrentPassword(this.email, this.currentPassword, this.newPassword);
        if(res){
          this.error = res;
          this.isResetError = true;
        }else{
          this.successMsg = "Password has been updated successfully!";
          this.isSuccess = true;
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Reset Password</h5>
                  <p>Re-Password with Skote.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >
              <b-alert
                v-model="isSuccess"
                class="mb-4"
                variant="success"
                dismissible
                >{{ successMsg }}</b-alert
              >
              <form @submit.prevent="tryToReset">
                <div class="form-group">
                  <div>
                    <label for="currentPassword">Current Password</label>
                    <input
                      type="password"
                      v-model="currentPassword"
                      class="form-control"
                      id="currentPassword"
                      placeholder="Enter current password"
                      :class="{
                        'is-invalid': submitted && $v.currentPassword.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.currentPassword.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.currentPassword.required"
                        >Current password is required.</span
                      >
                    </div>
                  </div>
                  <div>
                    <label for="newPassword">New Password</label>
                    <input
                      type="password"
                      v-model="newPassword"
                      class="form-control"
                      id="newPassword"
                      placeholder="Enter current password"
                      :class="{
                        'is-invalid': submitted && $v.newPassword.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.newPassword.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.newPassword.required"
                        >New password is required.</span
                      >
                    </div>
                  </div>
                  <div>
                    <label for="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      v-model="confirmPassword"
                      class="form-control"
                      id="confirmPassword"
                      placeholder="Enter current password"
                      :class="{
                        'is-invalid': submitted && $v.confirmPassword.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.confirmPassword.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.confirmPassword.required"
                        >Confirm password is required.</span
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-primary w-md" type="submit">
                      Update
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
